import React, { Suspense, lazy, useState, useContext, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Link, useHistory } from 'react-router-dom';
import PopupLogout from '../../views/pop-up/pop-up-logout';
import { AccountContext } from '../../aws-pool/Account';
import Pool from '../../aws-pool/login-pool';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { Common, decryptSingpassUserDetails, generateUniqueReferenceId } from '../../common/common';
import Loader from '../../views/CHCSA/loader';
// import PopupNRICSignUp from '../../views/pop-up/nric-only';
import { Auth } from 'aws-amplify';
import { ICON_USER_PROFILE_27x27 } from '../../common/images-s3';
import { CLIENT_PARAM, AHL_CHARITY_ID, NGS_SINGPASS_ENV, NGS_SINGPASS_URL, SESSION_EXPIRE_DURATION, SINGPASS_APPS, SINGPASS_LOGIN_PARAM, SINGPASS_PLATFORM, SINGPASS_QR_EXPIRE_DURATION, SINGPASS_SEPERATOR } from '../../common/constant';
import { EnrollService } from '../../jwt/_services/enrollment-service';
import { authContext } from '../../data/authContext';

import { useIdleTimer } from 'react-idle-timer';

const PopupAccountVerificationPending = lazy(() => import('../../views/pop-up/popup-ac-verification-pending'));
const PopupSignUp = lazy(() => import('./popup-signup'));
const ImageLoader = lazy(() => import('../../common/image-loader'));
const PopupLogin = lazy(() => import('./popup-login'));
const ForgotPassword = lazy(() => import('./forgot-password'));
const PopupNotRegisteredWarning = lazy(() => import('./popup-not-registered-warning'));
const PopupAlreadyRegisteredWarning = lazy(() => import('./popup-already-registered-warning'));

const ExternalLoader = () => {
    return (
        <>{ReactDOM.createPortal(<div className='sec-loader'><Loader /><div className='backdrop'></div></div>, document.getElementById('secLoader'))}</>
    )
}

const AuthErrors = {
    UserNotConfirmedException: 'UserNotConfirmedException',
    NotAuthorizedException: 'NotAuthorizedException',
    ServerException: "ServerException",
};

export const Login = (props) => {
    const { authenticate, logout, getSession } = useContext(AccountContext);
    const history = useHistory();
    const user = Pool.getCurrentUser();

    const [nricpopup, setnricpopup] = useState(false);
    const [socialType, setsocialType] = useState(null);
    const [showLoader, setShowLoader] = useState(false);
    const [name, setname] = useState(props.name ?? '');
    const [showHideLogoutPopup, setshowHideLogoutPopup] = useState(false);
    const [showLoginPopup, setShowLoginPopup] = useState(false);
    const [showSignUpPopup, setShowSignUpPopup] = useState(false);
    const [showForgotPassword, setForgotPassword] = useState(false);
    const [showAccountVerificationPopup, setShowAccountVerificationPopup] = useState(false);
    const [isVerificationSent, setisVerificationSent] = useState(false)
    const [isAccountVerified, setIsAccountVerified] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(Boolean(user));
    const [isUserNotRegistered, setIsUserNotRegistered] = useState(false);
    
    const [unableToFetchInfo, setUnableToFetchInfo] = useState(false)
    const [QRCodeExpired, setQRCodeExpired] = useState(false)
    const [singpassParam, setSingpassParam] = useState("")
    const [singpassScanError, setSingpassScanError] = useState({
        isError: false,
        type: null,
        message: ""
    })
    // const [showLoginWithEmail, setShowLoginWithEmail] = useState(false)
    const singpassQRTimerRef = useRef(undefined)

    const [signInError, setSignInError] = useState({
        type: '', message: '', data: {
            username: '',
            password: '',
        }
    });

    const resetSingpassErrors = () => {
        setSingpassScanError({
            isError: false,
            type: null,
            message: ""
        })
    }

    // Idle timer cases handling
    // const onPresenceChange = (presence) => {
    //     // Handle state changes in one function
    //   }
    
    //   const onPrompt = (event) => {
    //     // Fire a Modal Prompt
    //     console.log('onPrompt:', event);
    //   }
    
      const onIdle = () => {
        // Close Modal Prompt
        // Do some idle action like log out your user
        sessionStorage.setItem('isSessionExpired', true);
        localStorage.setItem('isSessionExpired', true);
        history.push({pathname: '/session-expired', state: {isSessionExpired: true, fromUrl: window.location.pathname}});
      }
    
    //   const onActive = (event) => {
    //     // Close Modal Prompt
    //     // Do some active action
    //     console.log('onActive:', event);
    //   }
    
      const onAction = (event) => {
        // Do something when a user triggers a watched event
        // console.log('onAction:', event);
      }
    
      const {
        start,
        // reset,
        // activate,
        // pause,
        // resume,
        // isIdle,
        // isPrompted,
        // isLeader,
        // isLastActiveTab,
        // getTabId,
        // getRemainingTime,
        // getElapsedTime,
        // getLastIdleTime,
        // getLastActiveTime,
        // getIdleTime,
        // getTotalIdleTime,
        // getActiveTime,
        // getTotalActiveTime
      } = useIdleTimer({
        // onPresenceChange,
        // onPrompt,
        onIdle,
        // onActive,
        onAction,
        timeout: SESSION_EXPIRE_DURATION,
        // promptBeforeIdle: 2000,
        debounce: 1000, // 1sec
        throttle: 0,
        eventsThrottle: 200,
        startOnMount: true, // 
        startManually: true, // StartOnMount wasn't working as expected hence enabled this
        stopOnIdle: false,
        crossTab: true,
        name: 'idle-timer',
        syncTimers: 0,
        leaderElection: false
      })

    const loginWithRedirect = () => {
        let isCTHTrxPassed = localStorage.getItem('isCTHTrxPassed');
        if (window.location.pathname !== '/' && isCTHTrxPassed == "false") {
            if (window.confirm("Changes you made may not be saved.")) {
                setShowLoginPopup(true);
                props.handlePopupIsOpen(true);
            }
        } else {
            setShowLoginPopup(true);
            props.handlePopupIsOpen(true);
        }
    }

    const handleClosePopupLogin = (e) => {
        e.preventDefault();
        setShowLoginPopup(true);
        setForgotPassword(false);
        setShowSignUpPopup(false);
        setshowHideLogoutPopup(false);
        setisVerificationSent(false);
        setShowAccountVerificationPopup(false);
        props.handlePopupIsOpen(false);
    }

    const handleCloseAccountVerificationPopup = (evt) => {
        evt.preventDefault();
        setShowLoginPopup(false);
        setForgotPassword(false);
        setShowSignUpPopup(false);
        setshowHideLogoutPopup(false);
        setisVerificationSent(false);
        setShowAccountVerificationPopup(false);
        props.handlePopupIsOpen(false);
    }

    const closePopup = (e) => {
        e?.preventDefault();
        setShowLoginPopup(false);
        setShowSignUpPopup(false);
        setshowHideLogoutPopup(false);
        setisVerificationSent(false);
        setShowAccountVerificationPopup(false);
        setSignInError({ type: '', message: '' });
        setIsUserNotRegistered(false);
        setSingpassScanError({ isError: false, type: null, message: "" })
        props.handlePopupIsOpen(false);
    }

    const socialSignIn = () => {
        socialType === 1 ? props.googleCall() : props.fbCall();
    }

    const onSuccessLogin = (e) => {
        // start(); // start idle timer once user successfully login
        setIsAuthenticated(true);
        setShowLoginPopup(false);
        history.push('/');
    }

    const onClickLogout = () => {
        let isCTHTrxPassed = localStorage.getItem('isCTHTrxPassed')
        if(window.location.pathname !== '/' && window.location.pathname !== '/profile' && isCTHTrxPassed == "false") {
            if(window.confirm("Changes you made may not be saved.")) {
                setShowLoader(true);

                // sessionStorage.removeItem("token");
                sessionStorage.clear()
                localStorage.removeItem('isAuthenticated');
                localStorage.removeItem('user_guid');

                setshowHideLogoutPopup(false);

                setShowLoader(false);

                if (props?.isFederatedSignIn) {
                    props?.socialSignOut();
                } else {
                    logout();
                }
            }
        } else {
            setShowLoader(true);

            // sessionStorage.removeItem("token");
            sessionStorage.clear()
            localStorage.removeItem('isAuthenticated');
            localStorage.removeItem('user_guid');

            setshowHideLogoutPopup(false);

            setShowLoader(false);

            if (props?.isFederatedSignIn) {
                props?.socialSignOut();
            } else {
                logout();
            }
        }


        // setShowLoader(true);

        // sessionStorage.removeItem("token");
        // localStorage.removeItem('isAuthenticated');
        // localStorage.removeItem('user_guid');

        // setshowHideLogoutPopup(false);

        // setShowLoader(false);

        // if (props?.isFederatedSignIn) {
        //     props?.socialSignOut();
        // } else {
        //     logout();
        // }

        // window.location.href = `/`;
    }

    const navLinkClick = (prevRoute) => {
        let target = document.querySelector('button.navbar-toggler');

        if (target) {
            let display = target?.currentStyle?.display || window?.getComputedStyle(target)?.display;

            if (display !== '' && display !== undefined && display !== 'none') {
                target.click();
            }
        }

        history.push('/profile');

        /**
         * Need to check if we are already on profile section or not
         * in case we are, only and only then reload the page else
         * simply don't in order to save performance
         */
        prevRoute.includes('profile') && window.location.reload();
    }

    const handleForgotPasswordPopup = (param) => {
        setForgotPassword(param);
        setShowLoginPopup(false);
        setShowSignUpPopup(false);
        setshowHideLogoutPopup(false);
        setisVerificationSent(false);
        setShowAccountVerificationPopup(false);
    }

    const showForm = (type, data) => {
        switch (type) {
            case 'LOGIN': {
                if (data?.type) {
                    setSignInError({
                        type: data.type,
                        message: data.message,
                        data: data.data
                    });
                    if (data.type === AuthErrors.UserNotConfirmedException) {
                        setShowLoginPopup(false);
                    }
                } else {
                    setShowLoginPopup(true);
                }
                setisVerificationSent(data?.signUpSucess ?? false);
                setShowSignUpPopup(false);
                setForgotPassword(false);
                setShowAccountVerificationPopup(false);
                break;
            }
            case 'SIGN_UP': {
                setnricpopup(false);
                setShowLoginPopup(false);
                setShowSignUpPopup(true);
                setForgotPassword(false);
                setShowAccountVerificationPopup(false);
                break;
            }
            case 'FORGOT_PASSWORD': {
                setShowLoginPopup(true);
                setShowSignUpPopup(false);
                setForgotPassword(false);
                setShowAccountVerificationPopup(false);
                break;
            }
            case 'CLOSE_ALL': {
                setnricpopup(false);
                setShowLoginPopup(false);
                setShowSignUpPopup(false);
                setShowAccountVerificationPopup(false);
                setisVerificationSent(false);
                setForgotPassword(false);
                props.handlePopupIsOpen(false);
                setSingpassScanError({ isError: false, type: null, message: "" })
                break;
            }
            case 'NIRC_UNIQUE': {
                setnricpopup(true);
                setShowSignUpPopup(false);
                setsocialType(data)
                break;
            }
            case 'NOT_REGISTERED': {
                if (data?.type === 'LOGIN') {
                    setnricpopup(false);
                    setShowLoginPopup(true);
                    setShowSignUpPopup(false);
                    setForgotPassword(false);
                    setShowAccountVerificationPopup(false);
                    setIsUserNotRegistered(false);
                } else if (data?.type === 'SIGN_UP') {
                    setnricpopup(false);
                    setShowLoginPopup(false);
                    setShowSignUpPopup(true);
                    setForgotPassword(false);
                    setShowAccountVerificationPopup(false);
                    setIsUserNotRegistered(false);
                }
                props?.setAuthorizedSocial();
                break;
            }
            default:
                break;
        }
    }

    const handleResendVerificationCode = (ev) => {
        const user = new CognitoUser({ Username: signInError.data.username, Pool: Pool });
        const ClinetMetaData = { "charityId": String(AHL_CHARITY_ID) }

        user.resendConfirmationCode((err, res) => {
            if (err) {
                console.error(err);
                closePopup();
            } else {
                closePopup(ev);
                showForm("LOGIN", { signUpSucess: true })
            }
        }, ClinetMetaData);
    };

    const closeWarning = () => {
        setShowAccountVerificationPopup(false)
    }

    useEffect(() => {

        setIsAuthenticated(Boolean(user));

        if (user && props.name === '') {
            getSession().then(data => setname(data.name))
        }

    }, [user, props, getSession, setname, name])

    const signinSingpassUser = (email, password) => {
        decryptSingpassUserDetails(password)
         .then(password => {
            authenticate(email, password)
                .then((response) => {
                    if (response.idToken.jwtToken !== "") {
                        // console.log('login response', response);
                        const countryCode = response.idToken?.payload['custom:COUNTRY_CODE'] ?? '';
                        let mobileNumber = response.idToken?.payload.phone_number ?? '';
                        let address = response.idToken?.payload.address?.formatted

                        if (Boolean(mobileNumber) && Boolean(countryCode)) {
                            mobileNumber = mobileNumber.replace(countryCode, '').match(/.{1,4}/g).join(' ');
                        }
                        // Set Auth details in context
                        authContext.isUserLoggedIn = true;
                        authContext.userEmail = response.idToken?.payload?.email;
                        authContext.userName = response.idToken?.payload?.name;
                        authContext.guid = response.idToken?.payload?.["cognito:username"];
                        localStorage.setItem("isAuthenticated", true);
                        localStorage.setItem("user_guid", authContext.guid);

                        onSuccessLogin();
                        props.updateName(response.idToken?.payload?.name);
                    }
                })
                .catch((error) => {
                    const _error = {
                        type: String(error).split(':')[0],
                        message: String(error).split(':')[1],
                        data: {
                            username: email,
                            password: password
                        }
                    }

                    // this.setState({
                    //     isInvalidCreds: ["NotAuthorizedException"].includes(_error.type),
                    //     isLoader: false,
                    //     errorMessage: error.message,
                    //     error: _error,
                    // });

                    showForm('LOGIN', _error)
                })
                .finally(() => {
                    // this.setState({ isLoader: false });
                });
         })
         .catch(err => console.log('error during decryption:', err))
    }

    const getSingpassCognitoUser = (data) => {
        const params = data.id?.split('_')
        const referenceNumber = params[1] // extract the referenceId from singpass response
        EnrollService.getSingpassCognitoUserDetails(referenceNumber)
            .then(response => {
                if(response.status === 1) {
                    signinSingpassUser(response.donorDetails.email, response.donorDetails.password)
                } else {
                    console.log('Fail response:', response)
                }
            })
            .catch(err => console.log('Error:', err))
    }

    useEffect(() => {
        start(); // Start/Reset the idle timer

        window.addEventListener("message", (event) => {
            if (event.origin === "https://staging.givepls.com" || event.origin === "https://app.givepls.com") {
                let signpassData = JSON.parse(event.data)

                // console.log("🚀 ~ file: login.js:395 ~ window.addEventListener ~ signpassData:", signpassData)
                // Hide verification email send message if user scanned the Singpass QR code
                setisVerificationSent(false);

                if(signpassData.statusCode === 0) {
                    setUnableToFetchInfo(true)
                } else if (signpassData.statusCode === 1 && signpassData.message?.toLowerCase() === 'success') {
                    getSingpassCognitoUser(signpassData)
                } else if (signpassData.statusCode === 2) {
                    setSingpassScanError({
                        isError: true,
                        type: 2,
                        message: signpassData.message ?? "Email id is not available in singpass",
                    });
                    generateSingpassParam(); // Refresh the QR code
                } else if (signpassData.statusCode === 3) {
                    setSingpassScanError({
                        isError: true,
                        type: 3,
                        message: signpassData.message ?? "Not singpass user",
                    })                
                } else if (signpassData.status === 'fail' && (signpassData.statusCode === 20 || signpassData.statusCode === 21 || signpassData.statusCode === 22)) {
                    setUnableToFetchInfo(true)
                } else if (signpassData.status === 'fail' && (signpassData.statusCode === 23 || signpassData.statusCode === 24)) {
                    // let singpassParam = PaymentContext?.paymentDetails?.transactionNo ? env + '_' + PaymentContext.paymentDetails.transactionNo + '_' + parseInt((new Date().getTime()).toFixed(0)) + "_web_sgverify_" + PaymentContext.donationMethod : false;
                    // iframeEle.src = iframeEle.src;
                } 
            }
        }, false);
    }, [])

    const startResetQRTimer = () => {
        if(singpassQRTimerRef.current) return;
        singpassQRTimerRef.current = setTimeout(() => {
            // this.setState({ QRCodeExpired: true }, () => {
            //     console.log('QR Code Expired')
            // })
            setQRCodeExpired(true)
        }, SINGPASS_QR_EXPIRE_DURATION) 
    }

    useEffect(() => {        
        if(!singpassParam) return;
        const url = NGS_SINGPASS_URL + "?id=" + singpassParam;

        fetch(url)
         .then(response => {
          if(!response.ok) setUnableToFetchInfo(true);
         })
         .catch(error => {
            console.log('Unable to fetch Singpass QR Code:', error);
            setUnableToFetchInfo(true);
         })
    }, [singpassParam])

    const generateSingpassParam = () => {
        // let PaymentContext = this.context.PaymentContext;
        singpassQRTimerRef && clearTimeout(singpassQRTimerRef.current);
        singpassQRTimerRef.current = null;

        const referenceId = generateUniqueReferenceId();
        let singpassParam = NGS_SINGPASS_ENV + SINGPASS_SEPERATOR + referenceId + SINGPASS_SEPERATOR + parseInt((new Date().getTime()).toFixed(0)) + SINGPASS_SEPERATOR + SINGPASS_PLATFORM + SINGPASS_SEPERATOR + SINGPASS_APPS.SGVERIFY + SINGPASS_SEPERATOR + 'cause' + SINGPASS_SEPERATOR + CLIENT_PARAM + SINGPASS_SEPERATOR + AHL_CHARITY_ID + SINGPASS_SEPERATOR + SINGPASS_LOGIN_PARAM;
       
        // this.setState({
        //     singpassParam: singpassParam,
        //     QRCodeExpired: false,
        // }, () => {
        //     console.log('singpassParam', singpassParam);
        //     setUnableToFetchInfo(false)
        //     startResetQRTimer()
        // })

        setSingpassParam(singpassParam)
        setQRCodeExpired(false)
        setUnableToFetchInfo(false)
        startResetQRTimer()

        return singpassParam;
    }

    return (
        <>
            {
                isAuthenticated ?
                    <>
                        <div className="c-btn">
                            <div className="c-img-name">
                                <div className="c-img">
                                    <Suspense fallback={null}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29">
                                            <g id="abstract-user-flat-1" transform="translate(-34.367 -34.367)" opacity="0.996">
                                                <circle id="Ellipse_264" data-name="Ellipse 264" cx="13.5" cy="13.5" r="13.5" transform="translate(35.367 35.367)" fill="none" stroke="#e78813" strokeWidth="2" />
                                                <circle id="Ellipse_265" data-name="Ellipse 265" cx="5.5" cy="5.5" r="5.5" transform="translate(43.367 39.367)" fill="none" stroke="#e78813" strokeWidth="2" />
                                                <path id="Path_5998" data-name="Path 5998" d="M106.819,352.138a10.727,10.727,0,0,1,20.218,0" transform="translate(-68.06 -293.778)" fill="none" stroke="#e78813" strokeWidth="2" />
                                            </g>
                                        </svg>
                                        {/* <ImageLoader type="image" src={ICON_USER_PROFILE_27x27}></ImageLoader> */}
                                    </Suspense>
                                </div>
                                <Link to={{ pathname: '/profile' }} className="user-name" onClick={() => navLinkClick(window.location.pathname)} title={name ?? props.name}>
                                    <span>
                                        {name ?? props.name}
                                    </span>
                                </Link>
                            </div>

                            <button
                                type="button"
                                className="btn btn-light btn-logout"
                                onClick={() => setshowHideLogoutPopup(true)}
                            >LOGOUT</button>
                        </div>
                        {showHideLogoutPopup && <PopupLogout closeLogoutPopup={closePopup} logoutUser={onClickLogout}></PopupLogout>}
                    </>
                    :
                    <>
                        <div className="c-btn">
                            <button type="button" className="btn btn-dark h-45" onClick={() => loginWithRedirect()}>Sign in</button>
                        </div>

                        <Suspense fallback={null}>
                            {
                                showLoginPopup &&
                                <PopupLogin
                                    googleSignIn={props.googleCall}
                                    fbSignIn={props.fbCall}
                                    socialSignInRedirect={socialSignIn}
                                    isVerificationSent={isVerificationSent}
                                    changeForm={showForm}
                                    authenticate={authenticate}
                                    loginSuccess={onSuccessLogin}
                                    showForgotPassword={handleForgotPasswordPopup}
                                    closePopup={handleClosePopupLogin}
                                    updateName={props.updateName}
                                    unableToFetch={unableToFetchInfo}
                                    setUnableToFetchInfo={setUnableToFetchInfo}
                                    singpassParam={singpassParam}
                                    QRCodeExpired={QRCodeExpired}
                                    generateSingpassParam={generateSingpassParam}
                                    setQRCodeExpired={setQRCodeExpired}
                                    singpassScanError={singpassScanError}
                                    resetSingpassErrors={resetSingpassErrors}
                                    // notSingpassUser={notSingpassUser}
                                    // setNotSingpassUser={setNotSingpassUser}
                                />
                            }
                            {
                                showSignUpPopup &&
                                <PopupSignUp
                                    changeForm={showForm}
                                    authenticate={authenticate}
                                    loginSuccess={onSuccessLogin}
                                    showForgotPassword={handleForgotPasswordPopup}
                                    closePopup={handleClosePopupLogin}
                                    googleSignUp={props.googleCall}
                                    fbSignUp={props.fbCall}
                                    unableToFetch={unableToFetchInfo}
                                    setUnableToFetchInfo={setUnableToFetchInfo}
                                    singpassParam={singpassParam}
                                    QRCodeExpired={QRCodeExpired}
                                    generateSingpassParam={generateSingpassParam}
                                    setQRCodeExpired={setQRCodeExpired}
                                    singpassScanError={singpassScanError}
                                    resetSingpassErrors={resetSingpassErrors}
                                    // notSingpassUser={notSingpassUser}
                                    // setNotSingpassUser={setNotSingpassUser}
                                />
                            }
                            {
                                showForgotPassword &&
                                <ForgotPassword
                                    closePopup={handleClosePopupLogin}
                                    showLoginPopup={(value) => {
                                        handleForgotPasswordPopup(false);
                                        showForm(value)
                                    }}
                                />
                            }
                            {
                                signInError.type === AuthErrors.UserNotConfirmedException && (
                                    <PopupAccountVerificationPending
                                        onClose={closePopup}
                                        onConfirm={handleResendVerificationCode}
                                    />
                                )
                            }
                            {/* {
                                nricpopup && <PopupNRICSignUp changeForm={showForm} socialSignInRedirect={socialSignIn} />
                            } */}
                            {
                                props?.isUnauthorizedLogin &&
                                <PopupNotRegisteredWarning
                                    changeForm={showForm}
                                    closePopup={props?.setAuthorizedSocial}
                                    setAuthorizedSocial={props?.setAuthorizedSocial}
                                />
                            }
                            {
                                props?.isPreRegistered &&
                                <PopupAlreadyRegisteredWarning
                                    changeForm={showForm}
                                    closePopup={props?.setAuthorizedSocial}
                                    setAuthorizedSocial={props?.setAuthorizedSocial}
                                />
                            }
                        </Suspense>
                        {showLoader && <ExternalLoader />}
                    </>
            }
        </>
    )
}